import { date, object, string } from 'yup'
import dayjs from 'dayjs'

const format = 'DD.MM.YYYY'

export const CreateAddValidateSchema = (data) => {
	return object().shape({
		subsidiaryContractNumber: string().required({ key: 'required' }).nullable(),
		subsidiaryContractDate: string()
			.nullable()
			.test(
				'is-before-contractDate-is-after-beginDate',
				null,
				function(value) {
					const { beginDate } = this.parent

					const begin = dayjs(beginDate, format)
					const val = dayjs(value, format)
					const contract = dayjs(data.item.contractDate, format)

					if (val.isBefore(contract)) {
						return this.createError({
							message: { key: 'contracts_civil_low.is_not_before_contractDate' },
						})
					}

					if (val.isAfter(begin)) {
						return this.createError({
							message: { key: 'contracts_civil_low.is_not_after_contractDate' },
						})
					}

					return true
				},
			),
		beginDate: string()
			.nullable()
			.test(
				'is-before-subsidiaryContractDate',
				{ key: 'contracts_civil_low.is_not_before_subsidiaryContractDate' },
				function(value) {
					const { subsidiaryContractDate } = this.parent

					const begin = dayjs(subsidiaryContractDate, format)
					const val = dayjs(value, format)

					if (val.isBefore(begin)) {
						return false
					}

					return true
				},
			),
		contractEndDate: string()
			.nullable()
			.test(
				'is-before-contractDate',
				{ key: 'contracts_civil_low.is_not_before_contractDate' },
				function(value) {
					const val = dayjs(value, format)
					const contract = dayjs(data.item.contractDate, format)

					if (val.isBefore(contract)) {
						return false
					}

					return true
				},
			),
		bin: string().required({ key: 'required' }).nullable(),
	})
}